const data = [
    {
        title: "Mount Fuji",
        location: "Japan",
        googleMapsUrl: "https://goo.gl/maps/1DGM5WrWnATgkSNB8",
        startDate: "12 Jan, 2021",
        endDate: "24 Jan, 2021",
        description: "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
        imageUrl: "./images/mount-fuji.jpg"
    },
    {
        title: "Sydney Opera House",
        location: "Australia",
        googleMapsUrl: "https://www.google.com/maps/place/Sydney+Opera+House/@-33.8567799,151.213108,17z/data=!3m2!4b1!5s0x6b12ae67d234a27f:0xd6d4e9380ca1e32f!4m5!3m4!1s0x6b12ae665e892fdd:0x3133f8d75a1ac251!8m2!3d-33.8567844!4d151.2152967",
        startDate: "27 May, 2021",
        endDate: "8 Jun, 2021",
        description: "The Sydney Opera House is a multi-venue performing arts centre in Sydney. Located on the banks of the Sydney Harbour, it is often regarded as one of the 20th century's most famous and distinctive buildings",
        imageUrl: "./images/sydney.jpg"
    },
    {
        title: "Geirangerfjord",
        location: "Norway",
        googleMapsUrl: "https://www.google.com/maps/place/Geirangerfjord/@62.1049113,7.0051736,12z/data=!3m1!4b1!4m5!3m4!1s0x46169d427b268c51:0xb8c99540dcc397fe!8m2!3d62.101506!4d7.0940816",
        startDate: "01 Oct, 2021",
        endDate: "18 Nov, 2021",
        description: "The Geiranger Fjord is a fjord in the Sunnmøre region of Møre og Romsdal county, Norway. It is located entirely in the Stranda Municipality.",
        imageUrl: "./images/gen.jpg"
    }
]

// <img decoding="async" src="https://lh5.googleusercontent.com/p/AF1QipMZS2nDQTd9ENuEBgUhxO61IhokrWKeQ-mXeEiQ=w408-h272-k-no" style="position: absolute; top: 50%;left: 50%;width: 408px;height: 272px;-webkit-transform: translateY(-50%) translateX(-50%);transform: translateY(-50%) translateX(-50%);">

// <img decoding="async" src="//lh5.googleusercontent.com/proxy/JSkvXt0AQwstCi_5FY0a14uYRpqMkOozWLz9y6LYaTiFeyB_Ow3ciFwLqZx-a-Myox2f63dW9NFHdxWuIJam4ihdD0C1mJPoc2B7brz_tdbRCx3aOUYe4XnKdS786lfBI_FjdF-4Ah04a1WqCsUKMnjjWYPwV78=w408-h257-k-no" style="position: absolute; top: 50%;left: 50%;width: 408px;height: 258px;-webkit-transform: translateY(-50%) translateX(-50%);transform: translateY(-50%) translateX(-50%);">

export default data;